<template>
  <a-modal
    title="意向方材料"
    :width="1100"
    :visible="visible"
    :footer="null"
    :destroyOnClose="true"
    @cancel="handleClose"
  >
    <a-table
      :columns="columns"
      :data-source="data"
      :loading="loading"
      rowKey="id"
      :pagination="pagination"
      @change="handleTableChange"
    >
      <span slot="operation" slot-scope="text, row" class="operation-link-cell">
        <a @click="downloadMaterial(row)">下载</a>
      </span>
    </a-table>
    <div class="modal-footer-center">
      <a-button @click="handleClose">关闭</a-button>
    </div>
  </a-modal>
</template>

<script>
import {
  downloadIntentionPartyMaterial,
  listIntentionPartyMaterial,
} from "@/api/project/Project.js";

export default {
  name: "IntentionMaterialModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      data: [],
      columns: [
        { title: "意向方类型", dataIndex: "partyType", align: "center" },
        { title: "意向方名称", dataIndex: "partyName", align: "center" },
        {
          title: "操作",
          width: 120,
          align: "center",
          scopedSlots: { customRender: "operation" },
        },
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条`,
      },
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.data = [];
        this.getList({ page: 1 });
      }
    },
  },
  methods: {
    getList(params = {}) {
      const webId = (this.record || {}).webId;
      if (!webId) return Promise.resolve();

      const page = params.page || this.pagination.current || 1;
      const pageSize = params.pageSize || this.pagination.pageSize || 10;
      this.loading = true;

      return listIntentionPartyMaterial({ webId, page, pageSize })
        .then((res) => {
          const pageData = this.normalizePageData(res);
          this.data = pageData.list;
          this.pagination = {
            ...this.pagination,
            current: pageData.pageNo,
            pageSize: pageData.pageSize,
            total: pageData.total,
          };
        })
        .catch((err) => {
          this.data = [];
          this.$notification["error"]({
            message: "意向方材料查询失败",
            description: this.getErrorMessage(err),
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleTableChange(pagination) {
      this.getList({
        page: pagination.current,
        pageSize: pagination.pageSize,
      });
    },

    downloadMaterial(row) {
      if (!row || !row.id) return;
      downloadIntentionPartyMaterial({ id: row.id })
        .then((blob) => {
          this.saveBlob(blob, row.fileName || "意向方材料");
        })
        .catch((err) => {
          this.$notification["error"]({
            message: "意向方材料下载失败",
            description: this.getErrorMessage(err),
          });
        });
    },

    handleClose() {
      this.$emit("close");
    },

    normalizePageData(res = {}) {
      const data = res.data || {};
      const list = Array.isArray(data.list)
        ? data.list
        : Array.isArray(res.data)
        ? res.data
        : [];

      return {
        list,
        total: Number(data.total || res.total || list.length || 0),
        pageNo: Number(data.pageNo || res.pageNo || res.current || 1),
        pageSize: Number(data.pageSize || res.pageSize || 10),
      };
    },

    saveBlob(blob, fileName) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },

    getErrorMessage(err) {
      return (
        ((err.response || {}).data || {}).msg ||
        ((err.response || {}).data || {}).message ||
        err.msg ||
        err.message ||
        "网络异常，请稍后再试"
      );
    },
  },
};
</script>

<style scoped>
.operation-link-cell a {
  color: #1890ff;
  font-weight: 500;
}

.modal-footer-center {
  margin-top: 28px;
  text-align: center;
}

.modal-footer-center .ant-btn {
  min-width: 120px;
}
</style>
